// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"dc98abbe","276":"39872319","358":"b4a45e98","453":"78bf416e","687":"0d368d96","839":"0e97dcce"}[chunkId] + ".chunk.js";
};